import { call, cancelled, put, select } from 'redux-saga/effects'
import getAPIConfig from '@/shared/tools/getAPIConfig'
import {
  updateAdditionalSalesModuleConfiguration
} from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSlice'
import { selectPageConfigurationData } from '@/store/PageConfiguration/PageConfigurationSelectors'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import {
  selectCommonFormConfigurationData
} from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSelectors'

export const additionalSalesActions = {
  ADDITIONAL_SALES_SEND_VALIDATION_CODE: 'ADDITIONAL_SALES_SEND_VALIDATION_CODE',
  ADDITIONAL_SALES_OPEN_SIGN_LINK: 'ADDITIONAL_SALES_OPEN_SIGN_LINK',
  ADDITIONAL_SALES_NEAT_RESEND_EMAIL: 'ADDITIONAL_SALES_NEAT_RESEND_EMAIL',
}

export function* openPandaDocSignLink({ zohoId }) {
  const { authTokenSession } = yield select(selectAuthData)
  const { panda_doc_sign_link_url: baseUrl } = yield select(selectPageConfigurationData)
  const backendUrl = baseUrl + '/' + zohoId
  yield put(updateAdditionalSalesModuleConfiguration({ openingSignLink: true }))
  const config = yield call(getAPIConfig, { method: 'get', authTokenSession })
  const response = yield call(fetch, backendUrl, config)
  const json = yield call([response, 'json'])

  if (response.ok && json.url) {
    console.log(response)
    console.log(json)
    yield call([window, 'open'], json.url, '_blank')
  } else {
    console.error('We couldn\'t retrieve sign panda link', json)
  }
  yield put(updateAdditionalSalesModuleConfiguration({ openingSignLink: false }))
}

export function* sendAdditionalSalesCodeValidation({ leadType, zohoId, email, phone }) {
  console.log('sendAdditionalSalesCodeValidation', leadType, zohoId, email, phone)
  const { authTokenSession } = yield select(selectAuthData)
  const { panda_doc_code_delivery_url: url } =
    yield select(selectPageConfigurationData)
  const { id: subscriptionId } = yield select(selectCommonFormConfigurationData)
  const controller = new AbortController()
  const signal = controller.signal

  try {
    yield put(updateAdditionalSalesModuleConfiguration({
      sendingCode: true,
      sendCodeError: null,
      sendCodeSuccess: false,
    }))

    const config = yield call(getAPIConfig, {
      method: 'post',
      authTokenSession,
      body: { leadType, subscriptionId, zohoId, ...(email && { email }), ...(phone && { phone }) },
    })
    const response = yield call(fetch, url, { ...config, signal })
    const json = yield call([response, response.json])

    if (!response.ok || json.errorCode) {
      yield put(updateAdditionalSalesModuleConfiguration({
        sendingCode: false,
        sendCodeSuccess: false,
        sendCodeError: json.message || JSON.stringify(json),
      }))
      return
    }
    yield put(updateAdditionalSalesModuleConfiguration({
      sendingCode: false,
      sendCodeSuccess: true,
    }))
  } catch (err) {
    console.warn('sendAdditionalSalesCodeError', err)
    yield put(updateAdditionalSalesModuleConfiguration({
      sendingCode: false,
      sendCodeError: err.message,
    }))
  } finally {
    if (yield cancelled()) {
      controller.abort()
      console.log('sendAdditionalSalesCode cancelled and aborted')
    }
  }
}

export function* resendNeatEmail({ leadType, subscriptionId, partnerId, signatureLink, updateLead }) {
  const { authTokenSession } = yield select(selectAuthData)
  const { neat_resend_email_url: url } =
    yield select(selectPageConfigurationData)
  const controller = new AbortController()
  const signal = controller.signal

  try {
    updateLead({
      sendingEmail: true,
      sendEmailSuccess: false,
      sendEmailError: false,
    }, leadType)

    const config = yield call(getAPIConfig, {
      method: 'post',
      authTokenSession,
      body: { leadType, subscriptionId, partnerId, signatureLink },
    })
    const response = yield call(fetch, url, { ...config, signal })
    const json = yield call([response, response.json])

    if (!response.ok || json.errorCode) {
      updateLead({
        sendEmailError: true,
        sendEmailSuccess: false,
      }, leadType)
      return
    }
    updateLead({
      sendEmailError: false,
      sendEmailSuccess: true,
    }, leadType)

    updateLead({
      sendingEmail: false,
      isModalOpened: false,
    }, leadType)
  } catch (err) {
    console.warn('resentNeatEmailError', err)
    updateLead({
      sendEmailError: true,
      sendEmailSuccess: false,
    }, leadType)
  } finally {
    if (yield cancelled()) {
      controller.abort()
      console.log('resentNeatEmail cancelled and aborted')
    }
  }
}
